// ============================================================================
// DataGrid Menu Positioning Utility
// ============================================================================
// Shared viewport-bounds adjustment for menus, popovers, and dropdowns.
// ============================================================================

import { toLayoutPx, rectToLayout } from 'shared/utils/zoom.js';

/**
 * Adjust a menu/popover position to keep it within viewport bounds.
 * Call AFTER the element is positioned and appended to the DOM.
 *
 * All measurements are converted to LAYOUT space (divided by the app zoom) so
 * the pixel positions we write back land correctly on a root-zoomed page. At
 * zoom 1 the conversions are no-ops.
 *
 * @param {HTMLElement} menu - The menu/popover element
 * @param {Object} [options]
 * @param {number} [options.padding=10] - Min distance from viewport edges
 * @param {DOMRect} [options.triggerRect] - If provided, menu flips above the trigger when overflowing vertically
 */
export function adjustMenuPosition(menu, { padding = 10, triggerRect = null } = {}) {
    const rect = rectToLayout(menu.getBoundingClientRect());
    const vw = toLayoutPx(window.innerWidth);
    const vh = toLayoutPx(window.innerHeight);
    const triggerTop = triggerRect ? toLayoutPx(triggerRect.top) : null;

    if (rect.right > vw - padding) {
        menu.style.left = `${Math.max(padding, vw - rect.width - padding)}px`;
    }
    if (rect.left < padding) {
        menu.style.left = `${padding}px`;
    }

    if (rect.bottom > vh - padding) {
        if (triggerTop !== null) {
            menu.style.top = `${triggerTop - rect.height - 5}px`;
        } else {
            menu.style.top = `${Math.max(padding, vh - rect.height - padding)}px`;
        }
    }
    if (rect.top < padding) {
        menu.style.top = `${padding}px`;
    }
}
